import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const quarterInReviewIframeStyle = {
  position: 'absolute',
  width: '100%',
  height: '100%',
  bottom: 0,
  right: 0,
  opacity: 0,
  zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
};